export default __webpack_public_path__ + "static/media/raginithopate.a35d8023.jpeg";